export default {
  name: "Номи шахси ҳуқуқӣ",
  entity: "Шахси ҳуқуқӣ",
  iik: "ИИК",
  inn: "ИНН",
  bin: "БИН",
  bic: "БИК",
  bankBic: "БИК бонк",
  codeFiscal: "Cod Fiscal",
  head_name_description:
    "Номи пурраи шахси масъулро ворид кунед, ки ба номи ӯ ҳисобҳо ва актҳо худкор сохта мешаванд",
  mainOrganization: "Шахси ҳуқуқии асосӣ",
  mainOrganizationHint:
    "Шахси ҳуқуқии асосӣ барои хариди тарофа истифода мешавад ва ҳангоми ғайрифаъолкунӣ фаъол боқӣ мемонад. Тағйири шахси ҳуқуқии асосӣ на бештар аз як маротиба дар 14 рӯз имконпазир аст",
  chooseMainOrganization: "Шахси ҳуқуқиро интихоб кунед",
  maxOrganizationError: "Шумораи максималии ташкилотҳо эҷод шудааст",
  moderOrganizationError:
    "Шумо наметавонед ташкилоти нав илова кунед, то анҷоми раванди модератсия",
  aboutTitle: "Маълумот дар бораи ташкилоти шумо",
  typeOrganization: "Навъи ташкилот",
  bankName: "Номи бонк",
  legalAddress: "Суроғаи ҳуқуқӣ",
  currentAccountNumber: "Рақами ҳисоби ҷорӣ",
  correspondentAccount: "Ҳисоби корреспондентӣ",
  vatCode: "Рамзи ААИ",
  addressFieldRequired: "Суроғаи шахси ҳуқуқӣ ворид нашудааст",
  metaIsRequired: "Маълумоти бонк ворид нашудааст",
  add: {
    button: "Ташкилот эҷод кунед",
  },
  registrationNumber: "Рақами бақайдгирӣ",
  // popup Aliexpress
  entities: "Шахсони ҳуқуқӣ",
  head_name: "Ному насаби роҳбар",
  ogrn: "ОГРН",
  ogrnOgrnip: "ОГРН / ОГРНИП",
  legalTypes: "Шакли ҳуқуқӣ",
  taxSystem: "Системаи андозбандӣ",
  monthlyTurnover: "Ҳаҷми гардиши моҳона",
  depositSum: "Маблағи амонат",
  okvedLabel: "Фаъолияти асосӣ",
  legalEntityCharter: "Оинномаи шахси ҳуқуқӣ",
  mainEntity: "Асосӣ",
  mainEntityInfo: [
    "Шахси ҳуқуқии асосӣ барои хариди тарофа истифода мешавад ва фаъол боқӣ мемонад, агар баъд аз анҷоми муҳлат тарофаи нав пардохт нашавад.",
    "Тағйири шахси ҳуқуқии асосӣ на бештар аз 1 маротиба дар 14 рӯз имкон дорад.",
  ],
  cantCreateModal: {
    title:
      "Шумо шумораи максималии шахсони ҳуқуқиро дар тарофаи худ эҷод кардед",
  },
  deposit: "Амонат",
  enterInnOrEntityName: "ИНН ё номи шахси ҳуқуқиро ворид кунед",
  entityCreating: "Эҷоди шахси ҳуқуқӣ",
  updateEntityNotifyMessage: {
    create: "Шахси ҳуқуқӣ ба модератсия фиристода шуд",
    edit: "Маълумоти шахси ҳуқуқӣ бомуваффақият тағйир дода шуд",
  },
  commercial: "Шахси ҳуқуқии тиҷоратӣ",
  uncommercial: "Шахси ҳуқуқии ғайритиҷоратӣ",
  depositMinSumHint:
    "Боќимондаи минималӣ дар ҳисоб. Маблағе на камтар аз {minDeposit} RC, ки ҳангоми гирифтани маблағ дар баланс боқӣ мемонад.",
  entityType: "Навъи шахси ҳуқуқӣ",
  entityInfo: "Маълумот дар бораи шахси ҳуқуқӣ",
  bankDetails: "Реквизитҳои бонкӣ",
  frequencyMainEntityChanging:
    "Тағйири шахси ҳуқуқии асосӣ на бештар аз як маротиба дар 14 рӯз имкон дорад.",
  abailableChangeMainEntity:
    "Тағйири шахси ҳуқуқии асосӣ аз {nextChangeDate} дастрас мешавад.",
  mainEntityDescription:
    "Барои хариди тарофа истифода мешавад ва фаъол боқӣ мемонад, агар баъд аз анҷоми муҳлат тарофаи нав пардохт нашавад.",
  entityHasHalal: "Шахси ҳуқуқӣ сертификати Ҳалол дорад",
  headNameToSendActs:
    "Ному насаби шахси масъул, ки ба номи ӯ актҳо ва ҳисобҳо худкор сохта мешаванд",
  certHalal: "Сертификати Ҳалол",
  makeMainEntity: "{entityName}-ро шахси ҳуқуқии асосӣ кардан?",
  successChangedMainEntity: "Шахси ҳуқуқии асосӣ бомуваффақият иваз шуд",
  mainEntityUseForBuyingTariff:
    "Шахси ҳуқуқии асосӣ барои хариди тарофа истифода мешавад ва фаъол боқӣ мемонад, агар баъд аз анҷоми муҳлат тарофаи нав пардохт нашавад.",
  afterConfirmYouCanChangeMainEntityIn14Days:
    "Баъди пахш кардани тугмаи «Тасдиқ», иваз кардани шахси ҳуқуқии асосӣ боз на пештар аз 14 рӯз имконпазир мешавад.",
  cancelCreationModal: {
    title: "Эҷоди шахси ҳуқуқиро бекор мекунед?",
    subtitle:
      "Маълумоти воридшуда нигоҳ дошта намешавад. Барои идома додани эҷод, тугмаи «Бозгашт»-ро пахш кунед.",
  },
  pressBackToSave:
    "Барои нигоҳ доштани тағйирот ё идомаи таҳрир, тугмаи «Бозгашт»-ро пахш кунед.",
  congratulateWithCreateEntity: "Табрик! Шахси ҳуқуқӣ эҷод шуд!",
  entityInModerationNow:
    "Дар ҳоли ҳозир шахси ҳуқуқии шумо дар санҷиш қарор дорад. Ин раванд аз 24 то 48 соатро дар бар мегирад.",
  toPassModerationPayBill:
    "Барои гузаштан аз санҷиш, ба шумо лозим аст ҳисобро аз номи шахси ҳуқуқии зикршуда пардохт кунед, онро тавассути тугмаи зер бор карда. Ҳисобро ҳамчунин метавонед дар ҳисоби шахсӣ дар қисмати «Корхонаҳои ман» - «Ҳуҷҷатҳо» бо номи «Пардохти санҷишӣ» пайдо кунед.",
};
